module.exports = __webpack_public_path__ + "static/media/illustration.04e66ba5839f61f8795c3e80248b3ed9.svg";